import { useQuery } from '@tanstack/react-query'
import { useAccessToken, useCurrentUser } from '@/features/auth/state/auth'

import api from '@/lib/api'

export function useFetchUserByIdGerente() {
  const user = useCurrentUser()
  const token = useAccessToken()

  return useQuery({
    queryKey: ['gerente'],
    queryFn: async () => {
      if (!user || !token) throw new Error('Usuário ou token ausente')

      const response = await api.get(`/user/gerente`, {
        headers: { Authorization: `Bearer ${token}` }
      })

      if (response.data && Array.isArray(response.data.data)) {
        return response.data.data
      }
      throw new Error('Estrutura de resposta inesperada')
    },
    enabled: Boolean(user && token)
  })
}
